import { casinoSection } from "./casinoSection.data";

export const EzugiGames = {
  ...casinoSection.AndarBahar,
  ...casinoSection.roulettetab,
  ...casinoSection.dragontiger,
  ...casinoSection.baccarattab,
  ...casinoSection.blackjacktab,
  ...casinoSection.pokertab,
  ...casinoSection.spribe,
};
